import "./CustomDropDown.css";
import { FaCaretDown, FaCaretUp, FaTimes } from "react-icons/fa";
import { forwardRef, useState } from "react";
import CustomSearch from "../CustomSearch";
const CustomMultiSelectDropdown = (
  {
    selected,
    setSelected,
    formik,
    fieldName,
    defaultSelectOption,
    options,
    fieldToShow,
    optionValue,
    isDisabled,
    disabledDropdown,
    onScroll,
    searchQuery,
    setSearchQuery,
    searchData,
    searchedRecord,
    setSearchedRecord,
    getDataByPage,
  },
  scrollRef
) => {
  const [active, setActive] = useState(false);

  return (
    <>
      <div className={`custom-dropdown ${disabledDropdown && "disabled"}`}>
        <div
          className={`custom-dropdown-btn`}
          onClick={() => {
            if (!disabledDropdown) {
              setActive(!active);
            }
          }}
        >
          <div className="d-flex flex-direction-r gap-10 flex-wrap">
            {selected?.length > 0
              ? selected.map((el, index) => (
                  <div
                    className="multiSelect-chip d-flex-align-cent gap-10"
                    key={index}
                  >
                    {el?.[fieldToShow]}
                    <div
                      className="d-flex-center cp rounded-circle cross-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelected(el, false);
                      }}
                    >
                      <FaTimes />
                    </div>
                  </div>
                ))
              : defaultSelectOption}
          </div>

          <div className="d-flex flex-direction-r gap-10 fs-18">
            <div className="dropdown-divider"></div>
            {active ? <FaCaretUp /> : <FaCaretDown />}
          </div>
        </div>
        {active && (
          <div
            className="custom-dropdown-content"
            ref={scrollRef}
            onScroll={onScroll}
          >
            <div className="mg-top-10">
              <CustomSearch
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                searchData={searchData}
                searchedRecord={searchedRecord}
                setSearchedRecord={setSearchedRecord}
                isVideoLibraryPage={true}
                getDataByPage={getDataByPage}
              />
            </div>
            {options?.length === 0 && (
              <p className="fs-14 semibold text-center mg-bottom-10">
                Record Not Found
              </p>
            )}
            {options?.map((item, index) => (
              <div
                className={`custom-dropdown-item ${
                  item[isDisabled] && "disabled-option"
                } ${!item[isDisabled] && "cp"}`}
                key={index}
                onClick={(event) => {
                  if (!item[isDisabled]) {
                    setSelected(item, true);
                    // if (setWeekValueAsWeekName) {
                    //   formik.setFieldValue("uploadVideoWeekName", item.name);
                    // }
                    // formik.setFieldValue(fieldName, item[optionValue]);
                    setActive(false);
                  }
                }}
              >
                {item[fieldToShow]}
              </div>
            ))}
          </div>
        )}
      </div>
      {/* <div className="errorMsg fs-14 medium">
        {formik.touched[fieldName] && formik.errors[fieldName]}
      </div> */}
    </>
  );
};

export default forwardRef(CustomMultiSelectDropdown);
